import { appRoles, CharteringManagerStatus, userRolesList } from "../../../utils/Constants";
export const RedirectionCase = (
  id?: number,
  status?: string,
  loggedInUserRole?: string | null,
  isDraftRequest?:boolean,
  isCharter?:boolean
) => {
  if (loggedInUserRole === appRoles.DeploymentUser && !isCharter) {
    switch (status) {
      case "DPL Assessment":
        return isDraftRequest ? `/RequestPage/FBPvalidation?requestId=${id}` : `/RequestPage/DtcoOverviewPage/${id}`;
        case "Case Withdrawn":
          return isDraftRequest ? `/RequestPage/FBPvalidation?requestId=${id}` : `/RequestPage/DtcoOverviewPage/${id}`;

      default:
        return `/RequestPage/DeploymentValidation?requestId=${id}`;
    }
  }
  if (
    (loggedInUserRole === appRoles.DeploymentHead ||
    loggedInUserRole === appRoles.FBP ||
    loggedInUserRole === appRoles.HONP || loggedInUserRole === appRoles.CharteringManager) && !isCharter
  ) {
    switch (status) {
      case "DPL Assessment":
        return `/RequestPage/DtcoOverviewPage/${id}`;
      case "Case Withdrawn":
          return `/RequestPage/DtcoOverviewPage/${id}`;
      default:
        return `/RequestPage/ProposalValidationScreen/${id}`;
    }
  }
  
  const isCharterPageAccessible = userRolesList.includes(loggedInUserRole as string);
  if(isCharterPageAccessible && isCharter){
    if(status == CharteringManagerStatus.New){
      return isDraftRequest ? `/CharterRequestPage/SaveValidationScreen/${id}` : `/CharterRequestPage/CharterOverviewPage/${id}`;
    }else if(status === CharteringManagerStatus.Closed){
      return `/CharterRequestPage/SaveValidationScreen/${id}`;
    }
  }
};
